import type { LanguageCode } from '@elfsight/configurator-contracts';

type SpeedUnit = 'km/h' | 'm/s' | 'mph';
type PressureUnit = 'hPa' | 'mmHg' | 'inHg';

export const DEFAULT_API_UNITS = 'imperial';
export const DEFAULT_LOCALE = 'en';

export const LOCALE_SPEED_UNITS: Record<LanguageCode, SpeedUnit> = {
  hy: 'm/s',
  az: 'm/s',
  be: 'm/s',
  da: 'm/s',
  'en-gb': 'mph',
  'en-us': 'mph',
  en: 'mph',
  et: 'm/s',
  fi: 'm/s',
  ka: 'm/s',
  is: 'm/s',
  ja: 'm/s',
  kk: 'm/s',
  ko: 'm/s',
  ky: 'm/s',
  lv: 'm/s',
  lt: 'm/s',
  no: 'm/s',
  ru: 'm/s',
  sv: 'm/s',
  uk: 'm/s',
  uz: 'm/s'
};

export const LOCALE_PRESSURE_UNITS: Record<LanguageCode, PressureUnit> = {
  hy: 'mmHg',
  az: 'mmHg',
  be: 'mmHg',
  'en-us': 'inHg',
  en: 'inHg',
  ka: 'mmHg',
  kk: 'mmHg',
  ky: 'mmHg',
  ru: 'mmHg',
  uk: 'mmHg',
  uz: 'mmHg'
};
